<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

defineProps<{
  records: any[],
  isSelected: Function,
}>()

defineEmits(['select', 'unselect'])

</script>

<template>
  <VFragment>
    <VTable v-if="records?.length">
      <thead>
        <tr>
          <th>ФИО</th>
          <th>Должность</th>
          <th>Основание</th>
          <th>Организация</th>
          <th class="text-center mw-100">
            Действие
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="record in records"
          :key="record.Bundle?.Uuid"
          :class="{ 'tr-deleted': record.Bundle?.IsDeleted}"
        >
          <!-- ФИО -->
          <td>
            {{ record.Fio || '—' }}
          </td>

          <!-- Должность -->
          <td>
            {{ record.Position || '—' }}
          </td>

          <!-- Основание -->
          <td>
            {{ record.Basis || '—' }}
          </td>

          <!-- Организация -->
          <td>
            {{ record.OrganizationName || '—' }}
          </td>

          <!-- Действие -->
          <td class="text-center">
            <WidgetRecordAction
              :selected="isSelected(record.Bundle?.Uuid)"
              @set="$emit('select', record)"
              @delete="$emit('unselect', record)"
            />
          </td>
        </tr>
      </tbody>
    </VTable>

    <VListItem v-else>
      Нет данных.
    </VListItem>
  </VFragment>
</template>

<style lang="scss" scoped>
.form-component-bottom {
  display: flex;
  align-items: center;
}

.form-component-bottom__pagination {
  flex-grow: 1;
}
</style>
